import { Injectable, OnDestroy } from '@angular/core';
import { CommunicationService } from './communication.service';
import { Subject, Subscription } from 'rxjs';
import { SidebarChangedEvent } from '../utils/events/sidebar-changed-event';
import { SidebarContentComponent } from '../components/sidebar/sidebar/sidebar-content-component';
import { PagesContentComponent } from '../components/sidebar/pages-content/pages-content.component';
import $ from 'jquery';

@Injectable({
    providedIn: 'root'
})
export class SidebarService implements OnDestroy {

    activeComponent: SidebarContentComponent;

    private hsmWasOpen = false;

    private pageTurnedSubscription: Subscription;
    private sidebarEventSource = new Subject<SidebarChangedEvent>();

    sidebarEventFired$ = this.sidebarEventSource.asObservable();

    constructor(private communicationService: CommunicationService) {

        this.pageTurnedSubscription = this.communicationService.pageTurnConfirmed$.subscribe(() => {

            if (this.activeComponent === PagesContentComponent) {
                this.scrollToActivePage();
            }
        });
    }

    ngOnDestroy(): void {
        this.pageTurnedSubscription.unsubscribe();
    }

    triggerSidebarChangeEvent(sidebarChangedEvent: SidebarChangedEvent): void {
        this.sidebarEventSource.next(sidebarChangedEvent);
    }

    closeSidebar(): void {
        this.sidebarEventSource.next(new SidebarChangedEvent(false));
    }

    scrollToActivePage(): void {

        setTimeout(() => {
            const element = $('.preview-container.active').first();

            if (element && element.offset()) {
                const container = $('.sidebar-content-wrapper');
                container.stop();
                const offset = element.offset().top - container.offset().top + container.scrollTop();
                container.animate({
                    scrollTop: offset - 10 - container.height() / 2 + element.height() / 2
                }, 1000);
            }
        }, 50);
    }

    wasHSMOpened(): boolean {
        return this.hsmWasOpen;
    }

    setHSMOpened(opened: boolean): void {
        this.hsmWasOpen = opened;
    }
}
